import 'what-input';
import { initNavigation } from './modules/navigation';
import { headerScroll } from './modules/header-scroll';
import { headerSearchToggle } from './modules/header-search-toggle';
import { accessibleLinkCards } from './modules/accessible-link-cards';
import { videoPopup } from './modules/video-popup';
import { gsapAnimations, gsapFadeInUp } from './modules/gsapAnimations';
import { gsapStaggerFade } from './modules/gsapStaggerFade';
import { animatedHeaders } from './modules/animatedHeaders';

const FARMSTAND_theme = (
  () => {
    'use strict'

    const publicAPIs = {}

    publicAPIs.init = () => {
      // functions that need to wait for the DOM to load
      if (document.readyState === 'interactive' || document.readyState === 'complete') {
        constructorEarly();
      } else {
        document.addEventListener('DOMContentLoaded', constructorEarly);
      }

      // functions that need to wait for the DOM and images/stylesheets to load
      if (document.readyState === 'complete') {
        constructorLate();
      } else {
        window.addEventListener('load', constructorLate);
      }
    }

    const constructorEarly = () => {
      // Functions to initialize early
    }

    const constructorLate = () => {
      // Functions to initialize late
      initNavigation();
      headerScroll();
      videoPopup();
      accessibleLinkCards();
      headerSearchToggle();
      gsapAnimations();
      gsapFadeInUp();
      gsapStaggerFade();
      animatedHeaders();
    }

    return publicAPIs
  }
)();

FARMSTAND_theme.init()
